import {Measurements} from "./measurements";

export class OutputMeasurements extends Measurements {
    constructor() {
        super();
        //Nur generieren, wenn mindestens 4 Außenwände vorhanden sind. Darunter nicht sinnvoll
        if (this.outerWalls.length < 4) {

        }
    }

    createOutsideMeasurements() {

    }

    createInsideMeasurements() {

    }

    createOpeningMeasurements() {

    }
}
